import React, { useEffect, useRef, useState } from 'react'
import './UpdatePageTopbar.css'
import { useDispatch, useSelector } from 'react-redux';
import { getAllTaskCategories, getAllTaskPriorities, getAllTaskTypes, getSingleTask } from '../../../../redux/TaskReducer/action';
import MultiDropdown from '../MultiDropdown/MultiDropdown';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'react-bootstrap-icons';

const UpdatePageTopbar = ({ componentName, newSubTask, setNewSubTask, setSubTaskType, filters, singleTask }) => {

    const { taskTypes, taskCategories, taskPriorities, tasks } = useSelector((store) => {
        return {
            taskTypes: store.TasksReducer.taskTypes,
            taskCategories: store.TasksReducer.taskCategories,
            taskPriorities: store.TasksReducer.taskPriorities,
            tasks: store.TasksReducer.tasks
        }
    });

    const [selectedOfficer, setSelectedOfficer] = useState("");
    const [selectedTaskType, setSelectedTaskType] = useState("");
    const { subtaskTypeId } = useParams();
    const [selectedSubtaskType, setSelectedSubtaskType] = useState("");
    const [remarksError, setRemarksError] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getAllTaskPriorities({
            is_active: true
        }));
        dispatch(getAllTaskTypes({
            is_active: true
        }));
    }, []);

    useEffect(() => {
        setSelectedTaskType(subtaskTypeId == 1 ? "DOCUMENT" : "FIELD");
    }, [subtaskTypeId]);

    useEffect(() => {
        if (!selectedTaskType && !selectedOfficer) {
            setNewSubTask(prev => ({
                ...prev,
                category_ids: []
            }));
            return;
        }

        // Clear previously selected subtypes
        setNewSubTask(prev => ({
            ...prev,
            category_ids: []
        }));

        dispatch(getAllTaskCategories({
            parent_category_name: selectedOfficer,
            category_type: selectedTaskType,
            is_active: true,
        }));
    }, [dispatch, selectedOfficer, selectedTaskType, selectedSubtaskType]);

    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === "title") {
            // prevent more than 500 actual characters
            const trimmedStart = value.replace(/^\s+/, "");
            const characterCount = trimmedStart.trim().length;

            if (characterCount > 500) return;

            let error = "";

            if (characterCount > 0 && characterCount < 10) {
                error = "Remarks must contain at least 10 characters.";
            }

            setRemarksError(error);

            setNewSubTask(prev => ({
                ...prev,
                [name]: trimmedStart
            }));

            return;
        }


        setNewSubTask(prev => ({
            ...prev,
            [name]: name === 'priority_id' || name === 'task_type_id' ? Number(value) : value
        }))
    }

    const handleCreateSubtask = async () => {
        if (isSaving) return;
        const remarksLength = newSubTask?.title?.trim()?.length || 0;

        if (remarksLength < 10) {
            setRemarksError("Remarks must contain at least 10 characters.");
            toast.error("Remarks must contain at least 10 characters.");
            return;
        }

        if (remarksLength > 500) {
            setRemarksError("Remarks cannot exceed 500 characters.");
            toast.error("Remarks cannot exceed 500 characters.");
            return;
        }

        let tokens = JSON.parse(sessionStorage.getItem("tokens")) || JSON.parse(localStorage.getItem("tokens")) || null;
        let authToken = tokens?.token || null;

        if (!authToken) {
            toast.error(`Invalid or missing token`);
            return;
        }

        let headers = {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
        }

        setIsSaving(true);

        try {
            let subtaskObj = {
                task_id: newSubTask.task_id,
                assigned_to: newSubTask.assigned_to,
                category_ids: newSubTask.category_ids,
                priority_id: newSubTask.priority_id,
                title: newSubTask.title.trim(),
                due_date: singleTask?.data?.due_date?.split('T')?.[0]
            };

            let res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/task/sub-task/create`, subtaskObj, { headers });

            if (res?.data?.data) {
                dispatch(getSingleTask(newSubTask?.task_id));
                toast.success(`Subtask created successfully`);

                setNewSubTask({
                    task_id: singleTask?.data?.task_id,
                    task_type_id: newSubTask?.task_type_id,
                    assigned_to: "",
                    category_ids: [],
                    priority_id: "",
                    title: "",
                    description: "",
                    due_date: ""
                });
                setSelectedOfficer("");
            }
        } catch (error) {
            let errMsg = error?.response?.data?.message;
            // console.log(error?.response?.data?.message);
            toast.error(`${errMsg}`);
        } finally {
            setIsSaving(false);
            // setNewSubTask({
            //     task_id: singleTask?.data?.task_id,
            //     task_type_id: newSubTask?.task_type_id,
            //     assigned_to: "",
            //     category_ids: [],
            //     priority_id: "",
            //     title: "",
            //     description: "",
            //     due_date: ""
            // });
            // setSelectedOfficer("");
        }
    }

    return (
        <div className="update-topbar">
            {/* <p className='topbar-title'>{componentName}</p> */}
            <p className='topbar-title'>{newSubTask?.task_type_id == 1 ? "Document" : "Data"} Update</p>

            <div className='item-grid'>
                <div className='selection-item'>
                    <label htmlFor="assigned_to">Officer</label>
                    <select
                        name="assigned_to"
                        id="assigned_to"
                        value={newSubTask.assigned_to}
                        onChange={(e) => {
                            handleChange(e);
                            setSelectedOfficer(e.target.value);
                        }}
                    >
                        <option value="">All Officers</option>
                        <option value="RO">RO</option>
                        <option value="BM">BM</option>
                        <option value="BCM">BCM</option>
                    </select>
                </div>
                <div className='selection-item'>
                    <label htmlFor="task_type_id">Type</label>
                    <select
                        name="task_type_id"
                        id="task_type_id"
                        value={newSubTask?.task_type_id}
                        onChange={(e) => {
                            handleChange(e);
                            console.log({ type: e.target.value })
                            let taskType = taskTypes?.find((t) => t.type_id === e.target.value);
                            setSelectedTaskType(taskType?.type_code)
                        }}
                        disabled
                    >
                        <option value="">All Types</option>
                        {
                            taskTypes?.map((type) => (
                                <option key={type.type_id} value={type.type_id}>
                                    {type.type_name}
                                </option>
                            ))
                        }
                    </select>
                </div>
                {/* <div className='selection-item'>
                <label htmlFor="category_ids">Subtype</label>
                <select 
                    name="category_ids" 
                    id="category_ids"
                    multiple
                    value={newSubTask.category_ids}
                    onChange={handleMultiSelectChange}
                >
                    <option value="">All Subtypes</option>
                    {
                        taskCategories?.map((category) => (
                            <option key={category.category_id}>
                                {category.category_name}
                            </option>
                        ))
                    }
                </select>
            </div> */}


                <div className="selection-item">
                    <label>Subtype</label>

                    <MultiDropdown
                        placeholder="All Subtypes"
                        selectedValues={newSubTask.category_ids}
                        onChange={(values) =>
                            setNewSubTask(prev => ({
                                ...prev,
                                category_ids: values
                            }))
                        }
                        options={
                            selectedOfficer ?
                                taskCategories
                                    ?.sort((a, b) =>
                                        a.category_name.localeCompare(b.category_name)
                                    )
                                    ?.map(cat => ({
                                        // id: cat.category_id,
                                        id: Number(cat.category_id), // ✅ ensure number
                                        label: cat.category_name
                                    })) || [] : []
                        }
                        resetKey={`${selectedOfficer}-${selectedTaskType}`}
                    />
                </div>


                <div className='selection-item'>
                    <label htmlFor="priority_id">Subtask Priority</label>
                    <select
                        name="priority_id"
                        id="priority_id"
                        value={newSubTask?.priority_id}
                        onChange={handleChange}
                    >
                        <option value="">All Priorities</option>
                        {
                            taskPriorities?.map((priority) => (
                                <option
                                    key={priority.priority_id}
                                    value={priority.priority_id}
                                    onClick={() => {
                                        setNewSubTask(prev => ({
                                            ...prev,
                                            priority_id: priority.priority_id
                                        }));
                                    }}
                                >
                                    {priority.priority_name}
                                </option>
                            ))
                        }
                    </select>
                </div>
                <div className='selection-item'>
                    <label htmlFor="title">Remarks*</label>
                    <input
                        type="text"
                        name="title"
                        id="title"
                        placeholder='Remarks'
                        value={newSubTask?.title}
                        onChange={handleChange}
                    />
                    <div className="remarks-footer">
                        <span
                            className={`remarks-count ${(newSubTask?.title?.trim()?.length || 0) >= 500
                                    ? "limit-reached"
                                    : ""
                                }`}
                        >
                            {500 - (newSubTask?.title?.trim()?.length || 0)} characters left
                        </span>

                        {remarksError && (
                            <span className="remarks-error">
                                {remarksError}
                            </span>
                        )}
                    </div>
                </div>
                {/* <div className='selection-item'>
                <label htmlFor="title">Title</label>
                <input 
                    type="text" 
                    name="title" 
                    id="title" 
                    placeholder='Title' 
                    value={newSubTask?.title}
                    onChange={handleChange}
                />
            </div> */}
                {/* <div className='selection-item'>
                <label htmlFor="description">Description</label>
                <input 
                    type="text" 
                    name="description" 
                    id="description" 
                    placeholder='Description' 
                    value={newSubTask?.description}
                    onChange={handleChange}
                />
            </div> */}
                {/* <div className='selection-item'>
                <label htmlFor="due_date">Due Date</label>
                <input
                    type="date" 
                    name="due_date"
                    value={newSubTask.due_date}
                    onChange={handleChange}
                    style={{
                        color: !newSubTask.due_date ? "var(--border-color)" : ""
                    }}
                />
            </div> */}
            </div>

            <div className='topbar-btn'>
                <button
                    className='primary-btn'
                    onClick={() => {
                        handleCreateSubtask();
                    }}
                    disabled={isSaving}
                >
                    {isSaving ? (
                        <>
                            <span className="buttonSpinner"></span>
                            Saving...
                        </>
                    ) : (
                        'Save Details'
                    )}
                </button>
                <button
                    className='secondary-btn'
                    onClick={() => {
                        navigate(`/applications/${singleTask?.data?.application_id}`)
                    }}
                >
                    Back to Application
                </button>
            </div>
        </div>
    )
}

export default UpdatePageTopbar